<app-grid-actions
  [actions]="gridActions"
  [customSelection]="userBackupSelection"
  [items]="userBackupSelection.getSelectedItems()"
  (clear)="userBackupSelection.deselectItems($event)"
>
  <button
    [disabled]="requestPending"
    (click)="generateQRCode()"
    data-qa="backup-generate-qr-code-button"
    type="button"
    class="proget-button text-only primary-button"
  >
    {{ 'backup.list.button.generate_qr_code.label' | translate }}
  </button>
</app-grid-actions>
<app-table
  [appRowActions]="gridActions"
  [customSelection]="userBackupSelection"
  [gridControl]="gridControl"
  [selection]="true"
  [value]="pagingList?.items"
>
  <ng-template
    [header]="'device_card.tab.backup.user_list.device.header' | translate"
    appColumn="device.model"
    let-item
  >
    <app-table-cell [value]="item.device.model">
      <ng-template>
        <app-ellipsis>
          <app-link [source]="item.device"></app-link>
        </app-ellipsis>
      </ng-template>
    </app-table-cell>
  </ng-template>
  <ng-template
    [header]="'device_card.tab.backup.user_list.device_uid.header' | translate"
    appColumn="device.uuid"
    let-item
  >
      <app-table-cell [value]="item.device.uuid"></app-table-cell>
  </ng-template>
  <ng-template
    [header]="'device_card.tab.backup.user_list.date.header' | translate"
    appColumn="date"
    let-item
  >
    <app-table-cell [value]="item.getDate()"></app-table-cell>
  </ng-template>
</app-table>
